import axios from "axios";
import DadosLocais from '@/services/helper/storage';

const dadosLocais = DadosLocais.getInstance();

// withCredentials: true — o navegador manda o cookie HttpOnly do token automaticamente em toda
// requisição pra Kernel API; não precisa mais montar o header Authorization manualmente.
const instance = axios.create({
  baseURL: process.env.VUE_APP_KERNEL_API,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// Dev local: mesmo rodando em localhost, esta instância chama sempre a Kernel API real
// (*.consultesaeweb.com.br) — chamada cross-site de verdade, então SameSite=Lax não manda o
// cookie de volta. A Kernel API só devolve o token no corpo pra esse cenário (ver
// EhOrigemDesenvolvimentoLocal, Kernel API) — usa esse valor pra montar o header aqui.
instance.interceptors.request.use((config) => {
  if (location.hostname === 'localhost') {
    const token = dadosLocais.getAccessToken();
    if (token) {
      config.headers!["Authorization"] = 'Bearer ' + token;
    }
  }
  return config;
});

export default instance;